import { render, staticRenderFns } from "./TipiTariffa.vue?vue&type=template&id=6c942ca2&"
import script from "./TipiTariffa.vue?vue&type=script&lang=ts&"
export * from "./TipiTariffa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports